module.exports = __webpack_public_path__ + "static/digiflynt-gcc-africa-e25e3e8a78a893bd22c40c68a8775817.jpeg";